export const signUpConfig = {
  hideAllDefaults: true,
  signUpFields: [
    {
      label: 'Metaverse or Company name, this creates your org',
      key: 'custom:companyName',
      required: true,
      placeholder: 'Metaverse name, Example: Westworld',
      type: 'text',
      displayOrder: 1,
    },
    {
      label: "Email, personal or work, for security you'll need to confirm your email",
      key: 'username',
      required: true,
      placeholder: "Your email i.e. @tesla.com, @gmail.com etc",
      type: 'email',
      displayOrder: 2,
    },
    {
      label: 'Password. Important: minimum 8 characters, with capital letter i.e. T, lower case i.e. x, number i.e. 5, and symbol i.e. !',
      key: 'password',
      required: true,
      placeholder: '8 chars min, one each upper, lower, number, symbol',
      type: 'password',
      displayOrder: 3,
    },
    {
      label: 'First Name, use any name you want others to know you by',
      key: 'given_name',
      required: true,
      placeholder: 'Name, alias, nickname, etc',
      type: 'text',
      displayOrder: 4,
    },
    {
      label: 'Last Name, use any name you want others to know you by',
      key: 'family_name',
      required: true,
      placeholder: 'Last Name, alias, nickname, etc',
      type: 'text',
      displayOrder: 5,
    },
  ],
  hiddenDefaults: ["email", "phone_number"]
}
